import { Button } from "@/components/ui/button/button";
import { copyToast } from "@/components/ui/common/copy";
import { Input } from "@/components/ui/input/input";
import type { PresaleView } from "../_types";
import { PresaleSection } from "./presale-section";

export const PRESALE_REFERRAL_SECTION_ID = "presale-refer";

/** 0–100, clamped — an over-filled group still reads as full. */
function foundingGroupProgressPercent(
  spotsReserved: number,
  spotsTotal: number,
): number {
  if (spotsTotal <= 0) return 0;
  const percent = Math.round((spotsReserved / spotsTotal) * 100);
  return Math.min(100, Math.max(0, percent));
}

/** "birdwatch.com/r/kevin-4sarah" — the link as people read it aloud. */
function displayUrl(url: string): string {
  return url.replace(/^https?:\/\//, "");
}

export function PresaleReferral({ view }: { view: PresaleView }) {
  const progress = foundingGroupProgressPercent(
    view.spotsReserved,
    view.campaign.spotsTotal,
  );

  return (
    <PresaleSection
      id={PRESALE_REFERRAL_SECTION_ID}
      title="Refer a neighbor"
      className="scroll-mt-6"
    >
      <p className="mt-3 text-base leading-normal text-text-dark-high text-pretty">
        We're closing the founding group at {view.campaign.spotsTotal} homes in{" "}
        {view.campaign.marketName}. Share your link and you'll both get a month
        on us.
      </p>
      <div
        role="progressbar"
        aria-label="Founding group filled"
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={progress}
        className="mt-5 h-1.5 overflow-hidden rounded-full bg-bg-dark-min"
      >
        <div
          className="h-full bg-bg-primary-max"
          style={{ width: `${progress}%` }}
        />
      </div>
      <div className="mt-5 flex items-center gap-3">
        <div className="min-w-0 flex-1">
          <Input
            value={displayUrl(view.referralUrl)}
            readOnly
            clearable={false}
          />
        </div>
        <Button size="xl" onClick={() => copyToast(view.referralUrl)}>
          Copy link
        </Button>
      </div>
    </PresaleSection>
  );
}
